/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";

// custom types
import { Language } from "types";
// graphql
import GET_LANGUAGES_CATEGORIES from "graphql/queries/GetLanguageCategory";
// styling
import {
  Dropdown,
  DropdownContent,
  StyledRowDiv,
  StyledColDiv,
  StyledContainer,
  DropBtn,
} from "./LanguageFilterStyle";

/* This components is used to tried to mimic Select's behavior.
    When clicked on different input radio, onChange will be called
    It is possible to style this component and changing the suffix icon (drop Icon)
    isLeftAlign is to make the dropdown left-align with the "select"(dropdown button) when it is true, right-align when it is false.
*/
type LanguageFilterProps = {
  onChange: (value: any) => void;
  filterLanguageId: string;
  languages: Language[];
  isLeftAlign?: boolean;
  noFixedSizeParent?: boolean;
  dropIcon?: JSX.Element;
  style?: React.CSSProperties;
  disabled?: boolean;
};

function LanguageFilterCommon(props: LanguageFilterProps) {
  const {
    onChange,
    filterLanguageId,
    languages,
    isLeftAlign,
    noFixedSizeParent,
    dropIcon,
    style,
    disabled,
  } = props;
  const [isActive, setIsActive] = useState(false);
  const btnRef = useRef(null);

  const { data: languageCategories } = useQuery(GET_LANGUAGES_CATEGORIES);

  const handleChange = (value: any) => {
    onChange(value as string);
    setIsActive(false);
  };
  const lc = languageCategories?.languagesCategory;

  const sortedLanguageCategories = lc
    ?.slice()
    .filter((langCat: any) => langCat.order && langCat.order < 6)
    .sort((a: any, b: any) => a.order - b.order);

  useEffect(() => {
    const closeDropdown = (e: any) => {
      if (!e.composedPath().includes(btnRef.current)) {
        setIsActive(false);
      }
    };
    document.body.addEventListener("click", closeDropdown);
    return () => document.body.removeEventListener("click", closeDropdown);
  });

  return (
    <div style={{ width: "100%" }}>
      {languages && languageCategories && (
        <Dropdown className="dropdown" style={style}>
          <DropBtn
            type="button"
            className={`dropbtn ${noFixedSizeParent ? "no-col" : "inside-col"}`}
            onClick={() => {
              if (!disabled) {
                setIsActive(!isActive);
              }
            }}
            ref={btnRef}
          >
            <span className="value-dropdown">
              {languages &&
                languages.find((lang: Language) => {
                  return lang.id === filterLanguageId;
                })?.englishName}{" "}
              {languages &&
                languages.find((lang: Language) => {
                  return lang.id === filterLanguageId;
                })?.realName}
            </span>
            {dropIcon}
          </DropBtn>
          <DropdownContent
            className={`dropdown-content ${isActive ? "active" : "disabled"} 
            ${isLeftAlign ? "left" : "right"}`}
          >
            <StyledRowDiv className="row">
              {sortedLanguageCategories?.map(
                (langCat: any) =>
                  langCat.languages.length > 0 && (
                    <StyledColDiv className="column" key={langCat.id}>
                      <span className="language-category-label">
                        {langCat?.name}
                      </span>
                      <StyledContainer>
                        {langCat.languages.map((lang: Language) => (
                          <div key={lang.id}>
                            <input
                              type="radio"
                              id={lang.id}
                              name="language"
                              onChange={() => handleChange(lang.id)}
                              checked={filterLanguageId === lang.id}
                            />
                            <label className="labels" htmlFor={lang.id}>
                              {lang.englishName}
                            </label>
                          </div>
                        ))}
                      </StyledContainer>
                    </StyledColDiv>
                  )
              )}
            </StyledRowDiv>
          </DropdownContent>
        </Dropdown>
      )}
    </div>
  );
}

export default LanguageFilterCommon;
